export const createScoresheetsRequests = (client) => ({
    listScoresheets: async (params) => {
        const { data, meta } = await client.api.get("scoresheets", {
            params: params,
        });
        return { data, meta };
    },
    findScoresheet: async (params) => {
        const { data } = await client.api.get("scoresheets", {
            params: params,
        });
        return data?.[0] ?? null;
    },
    findConsolidatedScoresheet: async (params) => {
        const { data } = await client.api.get(`consolidated_scoresheets/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createScoresheet: async (payload) => {
        const { data } = await client.api.create("scoresheet", payload);
        return { data };
    },
    autosaveScoresheet: async (payload) => {
        const { data } = await client.api.request({
            type: "scoresheet",
            url: `/scoresheets/${payload?.id}/autosave`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    updateScoresheet: async (payload) => {
        const { data } = await client.api.update("scoresheet", payload);
        return { data };
    },
    deleteScoresheet: async (payload) => {
        const { data } = await client.api.delete("scoresheet", payload);
        return { data };
    },
    finalizeScoresheet: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "scoresheets",
            url: "/scoresheets/consensus",
            body: payload,
        });
        return { data };
    },
    createFinalsScoresheet: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "scoresheets",
            url: "/scoresheets/finals",
            body: payload,
        });
        return { data };
    },
    compareScoresheets: async (params) => {
        const res = await client.api.request({
            method: "GET",
            type: "scoresheets",
            url: "/scoresheets/compare",
            params: params,
        });
        return res;
    },
    updateScoresheetsFeedback: async (payload) => {
        const { data } = await client.api.request({
            type: `scoresheets/${payload?.id}`,
            url: `/scoresheets/${payload?.id}/feedback`,
            body: payload,
            method: "PATCH",
        });
        return { data };
    },
    downloadScoresheet: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "scoresheets",
            url: `/scoresheets/${payload?.id}/download`,
        });
        return { data };
    },
    markScoresheetAsRead: async (payload) => {
        const { data } = await client.api.request({
            method: "PATCH",
            type: `scoresheets/${payload?.id}`,
            url: `/scoresheets/${payload?.id}/mark-as-read`,
            body: {
                id: payload?.id,
            },
        });
        return { data };
    },
    validateScoresheet: async (payload) => {
        const response = await client.api.request({
            method: "POST",
            type: `scoresheets/${payload.id}`,
            url: `/scoresheets/${payload.id}/validate`,
            body: payload,
        });
        return (response?.data?.data ??
            response?.data ??
            response);
    },
});
//# sourceMappingURL=index.js.map